export default __webpack_public_path__ + "static/media/3_1_3.015f6834.png";